import axios from 'axios'
const syncGet = (url) => {
  const xmlhttp = new XMLHttpRequest()
  xmlhttp.open('GET', url, false)
  xmlhttp.send(null)
  if (xmlhttp.status === 200) {
    return xmlhttp.responseText
  }
}
const getQRCodeUri = () => {
  if (process.env.NODE_ENV === 'production') {
    const http = '/_wechat_http_server_uri_'
    return syncGet(http)
  }
  return 'http://wx-api-dev.ihealthcn.com/'
}

const syncGetQRCode = async (postData) => {
  console.log('getQRCodeUri()', getQRCodeUri())
  const response = await axios.post(
    getQRCodeUri() + '/qrcodes/temporary',
    postData,
  )
  return response.data
}

export default syncGetQRCode



// WEBPACK FOOTER //
// ./src/common/QRCode.js